import { SkeletonLoader } from 'components/SkeletonLoader/SkeletonLoader';
import './QuoteEditorModuleSkeleton.scss';

const SKELETON_TOOL_ITEMS_COUNT = 5;
const SKELETON_ATTRIBUTE_COUNT = 10;
const SKELETON_FORM_FIELDS = 6;

/**
 * Skeleton de carga para el editor de cotizaciones.
 * Replica la estructura visual completa de QuoteEditorModule durante la carga inicial de datos.
 */
const QuoteEditorModuleSkeleton = () => {
  const toolItems = Array.from({ length: SKELETON_TOOL_ITEMS_COUNT });
  const attributes = Array.from({ length: SKELETON_ATTRIBUTE_COUNT });
  const formFields = Array.from({ length: SKELETON_FORM_FIELDS });

  return (
    <div className="quoteEditorModule">
      <div className="skeletonHeader">
        <div className="skeletonHeaderLeft">
          <SkeletonLoader width="5.6rem" height="5.6rem" />
          <div className="skeletonHeaderInfo">
            <div className="skeletonTitleRow">
              <SkeletonLoader width="16rem" height="2rem" />
              <SkeletonLoader width="9rem" height="2.4rem" variant="circular" customClassName="skeletonPill" />
            </div>
            <div className="skeletonHeaderMeta">
              {[6, 14, 10, 12, 8].map((w, i) => (
                <SkeletonLoader key={i} width={`${w}rem`} height="1.2rem" variant="circular" customClassName="skeletonPill" />
              ))}
            </div>
          </div>
        </div>
        <SkeletonLoader width="10rem" height="1.4rem" />
      </div>

      <div className="quoteEditorContent">
        <div className="skeletonToolList">
          <div className="skeletonToolListHeader">
            <SkeletonLoader width="14rem" height="1.2rem" />
            <SkeletonLoader width="3rem" height="1.2rem" />
          </div>
          <div className="skeletonProgressTrack">
            <SkeletonLoader width="100%" height="0.9rem" variant="circular" customClassName="skeletonPill" />
          </div>
          <div className="skeletonDivider" />
          <div className="skeletonToolListItems">
            {toolItems.map((_, i) => (
              <div key={i} className="skeletonToolItem">
                <div className="skeletonToolItemLeft">
                  <SkeletonLoader width="5.6rem" height="5.6rem" />
                  <div className="skeletonToolItemInfo">
                    <SkeletonLoader width="13rem" height="1.4rem" />
                    <SkeletonLoader width="9rem" height="1.2rem" />
                  </div>
                </div>
                <div className="skeletonToolItemStatus">
                  <SkeletonLoader width="0.8rem" height="0.8rem" variant="circular" />
                  <SkeletonLoader width="5rem" height="1.2rem" />
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="skeletonPanel">
          <div className="skeletonClientRequest">
            <div className="skeletonClientRequestTitle">
              <SkeletonLoader width="22rem" height="2rem" />
              <SkeletonLoader width="15rem" height="1.4rem" />
            </div>
            <div className="skeletonAttributeGrid">
              {attributes.map((_, i) => (
                <div key={i} className="skeletonAttribute">
                  <SkeletonLoader width="7rem" height="1rem" />
                  <SkeletonLoader width="10rem" height="1.4rem" />
                </div>
              ))}
            </div>
          </div>

          <div className="skeletonSuggestedTool">
            <div className="skeletonSuggestedToolHeader">
              <SkeletonLoader width="5.6rem" height="5.6rem" />
              <div className="skeletonSuggestedToolInfo">
                <SkeletonLoader width="18rem" height="1.6rem" />
                <SkeletonLoader width="10rem" height="1.2rem" />
              </div>
              <SkeletonLoader width="6rem" height="3.2rem" customClassName="skeletonBtn" />
            </div>
            <div className="skeletonFormGrid">
              {formFields.map((_, i) => (
                <div key={i} className="skeletonFormField">
                  <SkeletonLoader width="8rem" height="1.2rem" />
                  <SkeletonLoader width="100%" height="4.2rem" customClassName="skeletonBtn" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="skeletonFooter">
        <SkeletonLoader width="28rem" height="4.2rem" customClassName="skeletonBtn" />
        <SkeletonLoader width="28rem" height="4.2rem" customClassName="skeletonBtn" />
      </div>
    </div>
  );
};

export default QuoteEditorModuleSkeleton;
